<template>
    <div>
        <div class="load" v-if="isLoading"><loader></loader></div>
        <div v-else>
            <div class="extras-addicionales">
                <div class="extras-category" v-for="(i, index) in demoCat" :key="index">
                    <div class="card-header header-cat-title" @click="showCat(i)">
                        <div>
                            <i
                                class="fas fa-chevron-up"
                                v-if="showCatExtra === i.id_variant_cat"
                            ></i>
                            <i class="fas fa-chevron-down" v-else></i>
                            <span> {{ i.nameCat }} -- {{ i.preview_nameCat }}</span>
                            <span class="cdropdown btnViewMore float-right">
                                <button><i class="fas fa-ellipsis-v"></i></button>
                                <label>
                                    <input type="checkbox" />
                                    <ul>
                                        <li @click="activateEditAdi(i)">
                                            {{ $t("lang.label_edit") }}
                                        </li>
                                        <!-- <li @click="delCat(i)">
                                            {{ $t("lang.label_del") }}
                                        </li> -->
                                    </ul>
                                </label>
                            </span>
                        </div>
                    </div>
                    <div
                        v-bind:class="[
                            { activeLista: showCatExtra === i.id_variant_cat },
                            'showformop',
                            'extras-opciones',
                        ]"
                    >
                        <div class="extra-content">
                            <ul class="list-group">
                                <li
                                    class="list-group-item"
                                    v-for="(j, k) in i.a"
                                    :key="k"
                                    v-if="k !== 'nameCat' && k !== 'preview_nameCat'"
                                >
                                    <span>{{ j.name }}</span>
                                    <span
                                        class="badge badge-pill badge-light float-right extra-price"
                                    >
                                        {{ currency }}{{ j.price | formatMoney }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader";
import { mapGetters } from "vuex";
export default {
    name: "variantFormAside",
    components: {
        Loader,
    },
    data () {
        return {
            m: {
                show: false,
                component: "",
                data: [],
            },
            showCatExtra: 0,
            displayExtra: false,
            isLoading: false,
            btnSave: false,
            options: [],
            copiarExtra: [],
            currency: localStorage.getItem("currency"),
            f: {
                id: 0,
                name: "",
                preview_name: "",
                taks: [],
                org_id: window.localuserdata,
                user_id: window.master_client,
                category_id: 0,
                prices: "0.10",
                names: "",
                description: "",
                assing: 0,
                agruparOpt: [],
            },
            fVariant: {
                id: 0,
                org_id: window.localuserdata,
                user_id: window.master_client,
                taks: [],
                category_id: 0,
                idPrices: 0,
                action: false,
                agruparOpt: [],
            },
            demoCat: [],
            variantFormA: {
                idPrices: 0,
                category_id: 0,
                price: "0.10",
                agruparOpt: [],
            },
            assing: "",
        }
    },
    created () {
        this.init();
    },
    methods: {
        init() {
            // console.log(this.dataAsideMenu);
            if (
                this.dataAsideMenu.opts === "variant" &&
                this.dataAsideMenu.type === "food"
            ) {
                this.fVariant.action = true;
                let assing = this.dataAsideMenu.sizesList;
                this.demoCat = [];
                this.demoCat = assing;
                this.demoCat = this.removeDuplicatesKeyValues(
                    this.demoCat,
                    "id_variant_cat"
                );
                this.f.agruparOpt = [];
                this.f.agruparOpt = this.dataAsideMenu.agruparOpt;
                this.fVariant.agruparOpt = [];
                this.fVariant.agruparOpt = this.dataAsideMenu.agruparOpt;
            } else {
                this.fVariant.action = false;
                this.demoCat = [];
            }
            let r = this.dataAsideMenu;
            this.f.names = r.names;
            this.f.description = r.description;
            this.f.category_id = r.id_category;
            this.f.id = r.id;
            // this.getData();
            this.variantFormA.idPrices = r.id;
            this.variantFormA.category_id = r.id_category;
            this.variantFormA.agruparOpt = this.dataAsideMenu.agruparOpt;
        },
        delCat(i) {
            this.$swal({
                title: window.lang2.label_del_extra,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    this.f.id_variant_cat = i.id_variant_cat;
                    let url = "/menu/delVariantCatAssing";
                    window.master.post(url, this.f).then((response) => {
                        // console.log(response.data.assing)
                        let assing = response.data.assing;
                        this.assing = "variantFormAsideReturn";
                        this.fVariant.agruparOpt = [];
                        this.f.agruparOpt = [];
                        for (const i in assing) {
                            this.fVariant.agruparOpt.push(assing[i]);
                            this.f.agruparOpt.push(assing[i]);
                        }
                        this.fVariant.agruparOpt = this.removeDuplicatesValues(
                            this.fVariant.agruparOpt
                        );
                        this.f.agruparOpt = this.removeDuplicatesValues(
                            this.f.agruparOpt
                        );
                        this.returnVariant(assing);
                        this.displayExtra = false;
                        this.isLoading = false;
                    });
                }
            });
        },
        activateEditAdi(i) {
            let t = this;
            let y = [];
            y.push({
                idPrices: t.f.id,
                category_id: t.f.category_id,
                name: i.nameCat,
                preview_name: i.preview_nameCat,
                id: i.id_variant_cat,
                action: "variantFormAside",
                varian: true,
                agruparOpt: t.f.agruparOpt,
            });
            this.m = {
                // show: true,
                shown: true,
                component: "variantForm",
                data: {
                    dat: y[0],
                },
            };
            this.$store.commit("setOpenModal", this.m);
        },
        showCat(i) {
            this.showCatExtra = 0;
            this.showCatExtra = i.id_variant_cat;
        },
        activeExtra() {
            this.displayExtra = !this.displayExtra;
            if (this.displayExtra === true) {
                this.showCatExtra = 0;
            }
            let data = {
                function: "hidden",
            };
            this.$store.commit("setvariantData", data);
        },
        resfresh() {
            this.f.preview_name = "";
            this.f.name = "";
            this.f.prices = 0;
            this.copiarExtra = [];

            this.fVariant.id = 0;
            this.fVariant.taks = [];
            this.fVariant.idCat = 0;
            this.fVariant.idFood = 0;
        },
        getData() {
            this.isLoading = true;
            let url = "/menu/variantopts";
            window.master
                .post(url, this.f)
                .then((response) => {
                    let u = response.data.res;
                    this.options = u;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        hiddenCat() {
            this.displayExtra = false;
            let data = {
                function: "show",
            };
            this.$store.commit("setvariantData", data);
        },
        CopiarExtas() {
            if (this.copiarExtra.length === 0) {
                this.$swal.fire({
                    type: "warning",
                    title: "Vacio",
                    text: "Seleccione una Variante",
                    showConfirmButton: false,
                    timer: 2000,
                });
            } else {
                this.f.assing = this.copiarExtra.id;
                this.btnSave = true;
                let url = "/menu/variantformassing";
                window.master
                    .post(url, this.f)
                    .then((response) => {
                        this.$swal.fire({
                            type: "success",
                            title: "Save!",
                            text: "Save Successful",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        this.btnSave = false;
                        this.displayExtra = false;
                        this.assing = "assing";
                        this.returnVariant(this.f.assing);
                    })
                    .catch((error) => {
                        this.displayExtra = false;
                        this.btnSave = false;
                        console.log(error);
                    });
            }
        },
        returnVariant(assing) {
            this.fVariant.id = assing;
            if (this.assing === "assing") {
                this.fVariant.agruparOpt.push(assing);
                this.f.agruparOpt.push(assing);
                this.fVariant.agruparOpt = this.removeDuplicatesValues(
                    this.fVariant.agruparOpt
                );
                this.f.agruparOpt = this.removeDuplicatesValues(this.f.agruparOpt);
            }
            this.fVariant.category_id = this.dataAsideMenu.id_category;
            this.fVariant.idPrices = this.dataAsideMenu.id;
            this.fVariant.action = true;
            let url = "/menu/variantopt";
            window.master
                .post(url, this.fVariant)
                .then((response) => {
                    let u = response.data.res;
                    let assing = response.data.assing;
                    // this.getData();
                    // console.log(response.data);
                    let m = [];
                    let sizesList = [];
                    let b = [];
                    let food_id = this.f.id;
                    for (let i in u) {
                        let o = u[i];
                        let a = [];
                        for (let j in o) {
                            m.push(o[j]);
                            if (
                                o[j].id_variant_cat !== undefined &&
                                o[j].id !== undefined
                            ) {
                                a.push({
                                    food_id: food_id,
                                    idPrices: o[j].id_variant_prices,
                                    id_variant_cat: o[j].id_variant_cat,
                                    name: o[j].name,
                                    price: o[j].price,
                                    id: o[j].id,
                                });
                            }
                            if (
                                o[j].id_variant_cat !== undefined &&
                                o[j].name !== undefined &&
                                o[j].price !== undefined &&
                                o[j].price !== undefined
                            ) {
                                b.push({
                                    food_id: food_id,
                                    id: o[j].id_variant_prices,
                                    id_variant_cat: o[j].id_variant_cat,
                                    nameCat: u[i].nameCat,
                                    name_size: o[j].name,
                                    preview_nameCat: u[i].preview_nameCat,
                                    price: o[j].price,
                                    size_id: o[j].id,
                                });
                            }
                        }
                        sizesList.push({
                            id_variant_cat: u[i][0].id_variant_cat,
                            nameCat: u[i].nameCat,
                            preview_nameCat: u[i].preview_nameCat,
                            a,
                        });
                    }
                    this.showCatExtra = 0;
                    this.demoCat = [];
                    let sizesL = sizesList;
                    for (const i in sizesL) {
                        this.demoCat.push(sizesL[i]);
                    }
                    let agruparOpt = [];
                    let c = [];
                    for (let y in assing) {
                        let a = [];
                        for (let i in b) {
                            if (b[i].id_variant_cat === assing[y]) {
                                a.push({
                                    food_id: b[i].food_id,
                                    id: b[i].id,
                                    id_variant_cat: b[i].id_variant_cat,
                                    nameCat: b[i].nameCat,
                                    name_size: b[i].name_size,
                                    preview_nameCat: b[i].preview_nameCat,
                                    price: b[i].price,
                                    size_id: b[i].size_id,
                                });
                            }
                        }
                        c.push(a);
                    }
                    for (let i in c) {
                        let u = c[i];
                        for (let i = 0; i < 1; i++) {
                            agruparOpt.push(u[0]);
                        }
                    }

                    let t = this;
                    let data = {
                        function: "returnVariant",
                        agruparOpt: agruparOpt,
                        platosPrices: b,
                        idCat: t.fVariant.category_id,
                        idFood: t.fVariant.idPrices,
                    };
                    // console.log(data);
                    this.arrays(data);
                    this.resfresh();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        arrays(data) {
            this.$store.commit("setvariantData", data);
        },
        removeDuplicatesKeyValues(originalArray, prop) {
            var newArray = [];
            var lookupObject = {};

            for (var i in originalArray) {
                lookupObject[originalArray[i][prop]] = originalArray[i];
            }

            for (i in lookupObject) {
                newArray.push(lookupObject[i]);
            }
            return newArray;
        },
        removeDuplicatesValues(array) {
            const dataArr = new Set(array);
            let result = [...dataArr];
            return result;
        },
    },
    computed: {
        ...mapGetters(["get_menuCatActive", "dataAsideMenu", "getvariantData"]),
    },
    watch: {
        getvariantData() {
            this.showCatExtra = 0;
            let functions = this.getvariantData.function;
            if (functions === "cancelarAside") {
                this.displayExtra = false;
            }
            if (functions === "variantFormAsideReturn") {
                this.assing = "variantFormAsideReturn";
                let assing = this.getvariantData.agruparOpt;
                this.fVariant.agruparOpt = [];
                this.f.agruparOpt = [];
                for (const i in assing) {
                    this.fVariant.agruparOpt.push(assing[i]);
                    this.f.agruparOpt.push(assing[i]);
                }
                this.fVariant.agruparOpt = this.removeDuplicatesValues(
                    this.fVariant.agruparOpt
                );
                this.f.agruparOpt = this.removeDuplicatesValues(this.f.agruparOpt);
                this.returnVariant(assing);
                this.displayExtra = false;
            }
        },
        dataAsideMenu: function () {
            // console.log(this.dataAsideMenu);
            if (
                this.dataAsideMenu.opts === "variant" &&
                this.dataAsideMenu.type === "food"
            ) {
                this.fVariant.action = true;
                let assing = this.dataAsideMenu.sizesList;
                this.demoCat = [];
                this.demoCat = assing;
                this.demoCat = this.removeDuplicatesKeyValues(
                    this.demoCat,
                    "id_variant_cat"
                );
                this.f.agruparOpt = [];
                this.f.agruparOpt = this.dataAsideMenu.agruparOpt;
                this.fVariant.agruparOpt = [];
                this.fVariant.agruparOpt = this.dataAsideMenu.agruparOpt;
            } else {
                this.fVariant.action = false;
                this.demoCat = [];
            }
            let r = this.dataAsideMenu;
            this.f.names = r.names;
            this.f.description = r.description;
            this.f.category_id = r.id_category;
            this.f.id = r.id;
            // this.getData();
            this.displayExtra = false;
            this.variantFormA.idPrices = r.id;
            this.variantFormA.category_id = r.id_category;
            this.variantFormA.variantFormA = this.dataAsideMenu.agruparOpt;
        },
        preselect: function () {
            this.formOp.incluir = this.preselect === true ? 1 : 0;
        },
    },
}
</script>
<style lang="scss" scoped>
.extras-addicionales {
    margin-bottom: 100px;
}
.multiselect {
    max-width: 85% !important;
}
.extra-content {
    padding: 0px 1px 5px 5px;
}
.extra-content ul.list-group li.list-group-item {
    padding: 5px;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.btn-add-group2 {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: auto;
    display: block;
    margin: 0px auto;
}
.cdropdown.btnViewMore > a:before,
.cdropdown.btnViewMore > button:before {
    content: "" !important;
    border-top: 0px;
    border-left: 0px;
    top: 0px;
    right: 0px;
    border-right: 0px;
}
.cdropdown.btnViewMore > a,
.cdropdown.btnViewMore > button {
    padding-right: 5px;
    padding-left: 5px;
    border: 0px;
}
.cdropdown.btnViewMore ul {
    right: 0px;
}
span.cdropdown.btnViewMore.float-right button {
    padding: 0px;
}
.extra-price {
    margin-right: 10px;
}
.row-add-extras {
    margin: 20px 0px 0px 0px;
}
.form-extra-add {
    display: none;
}
.form-extra-add.activeForm {
    display: block;
}

.extras-opciones {
    height: 0px;
    transform: scaleY(0);
    overflow: hidden;
    transition: transform 0.3s ease-out;
}
.activeLista.extras-opciones {
    overflow: initial !important;
    height: auto !important;
    transform: scaleY(1);
    transform-origin: top;
    border: 1px solid #727272;
    border-top: 0px;
    padding-top: 5px;
}
.activeLista.showformop.extras-opciones .extra-content {
    padding-left: 0px !important;
}
form.form-horizontal {
    background: #f7f7f7;
    padding: 5px;
}
form.form-horizontal input[type="text"] {
    border: 1px solid rgb(177, 177, 177);
}
.card-header.header-cat-title {
    color: #727272;
    font-size: 14px;
    font-weight: bold;
    border: 1px solid #727272;
    margin-top: 5px;
}
.multiselect {
    max-width: 210px;
}
.multiselect__tags {
    border: 1px solid #b1b1b1;
    border-top-left-radius: 2px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 2px;
}
.form-control {
    width: 80% !important;
}
</style>
